import { render, staticRenderFns } from "./donationIntroduction.vue?vue&type=template&id=0387a116&"
import script from "./donationIntroduction.vue?vue&type=script&lang=js&"
export * from "./donationIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./donationIntroduction.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports